// import the interface
import { AdminUserActionType,All } from '../actions/adminuser.action';

//create a dummy initial state
export interface State {
  // is a user authenticated?
  isAuthenticated: boolean;
  // if authenticated, there should be a user object
  adminuser?: any;
  // error message
  errorMessage: string | null;
}

export const initialState: State = {
  isAuthenticated: false,
  errorMessage: null
};

export function adminuserReducer(
  state = initialState,
  action: All
) {
  switch (action.type) {
    case AdminUserActionType.GETAdmin_INFO:
      return state;
    case AdminUserActionType.INFOAdmin_SUCCESS:
        return {...state, adminuser:action.payload?.data};
    default:
      return state;
  }
}

